// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const space = [0, 4, 8, 16, 32, 64, 128, 256, 512]

export default space
